import { useMutation, useQueryClient } from "@tanstack/react-query";
import { renameList } from "common/apis/savedplaces";
import { Storage } from "common/storage";

export function useRenameList() {
  const accessToken = Storage.getCurrentUserToken();
  const queryClient = useQueryClient();

  const { mutate, data, error, status } = useMutation({
    mutationFn: ({
      name,
      savedListId,
    }: {
      name: string;
      savedListId: string;
    }) => {
      return renameList(savedListId, accessToken, name);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["getAllSavedPlaces"],
        exact: false,
      });
    },
  });

  return {
    renameList: mutate,
    result: data,
    error,
    status,
    isLoading: status === "pending",
  };
}
